<template>
  <b-row no-gutters>
    <b-col>
      <div class="boxed">
        <b-row align-h="between" align-v="center">
          <b-col>
            <div>
              <p class="p-3 mb-0 font-weight-bold">
                {{ title }}
              </p>
            </div>
            <div class="pb-2">
              <slot name="header"></slot>
            </div>
          </b-col>
          <b-col cols="auto" class="mr-4">
            <span @click="() => (isOpen = !isOpen)">
              <font-awesome-icon v-if="toggle" class="open-close" :icon="!isOpen ? 'chevron-down' : 'chevron-up'" />
            </span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="px-4 py-2" v-if="isOpen">
              <slot name="content"></slot>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    toggle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: false,
    }
  },
}
</script>

<style lang="scss" scoped>
.open-close {
  font-size: 20px;
  cursor: pointer;
}
.rotated {
  transform: rotateX(180deg);
}
.boxed {
  background-color: #ccd5e2;
}
.bg-box-color {
  background-color: var(--secondaryBGColor);
}
</style>
